// extracted by mini-css-extract-plugin
export default {"flex-center":"alignment_flex-center__wrP0X"};